import { render, staticRenderFns } from "./ListaExtratoAutorizacaoCard.vue?vue&type=template&id=4c062016"
import script from "./ListaExtratoAutorizacaoCard.vue?vue&type=script&lang=js"
export * from "./ListaExtratoAutorizacaoCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports